import React from "react";
import SupportMain from "../../components/support";
const SupportAll = () => {
  return <SupportMain />;
};

export default SupportAll;
